module.exports = __webpack_public_path__ + "assets/img/high-severity-statistics.f2cd72b5.svg";